/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
import { convertToError } from './convertToError';

export default convertToError;
/**
 * @deprecated Use `import { convertToError } from '@atlaskit/frontend-utilities'` instead.
 */
export { convertToError } from './convertToError';
